<script lang="ts">
	//UI
	import { DefaultButton, DeleteIcon } from "@hitit/new_ui";
	import ContainerLoading from "@hitit/hub/src/v7/components/common/ContainerLoading.svelte";
	import Profile from "../component/User/Profile.svelte";
	import AdditionalInfo from "../component/User/AdditionalInfo.svelte";
	import OwnStore from "../component/User/OwnStore.svelte";
	import UserEventLogging from "../component/User/UserEventLogging.svelte";
	//Utils
	import { api, t } from "@hitit/hub/src/stores";
	import { popup } from "@hitit/hub/src/v7/store";
	import { onDestroy } from "svelte";
	//Types
	import type { AccessControlDTO, ProfileData, UserData } from "@hitit/api";
	import AreYouSure from "@hitit/hub/src/v7/components/common/AreYouSure.svelte";
	import { navigate } from "svelte-routing";

	//Props
	export let userId = "";

	//Constants
	const deleteButtonBackground = "#f66d6c";
	//Variables
	let loading = false;
	let user: UserData;
	let profile: ProfileData;
	let accessControlList: AccessControlDTO[];

	let azureUserText = "Azure에서 관리중인 유저입니다."
	let azureProfile = {
		cellphone: azureUserText,
		cellphoneVerified: true,
		emailVerified: true,
		cellphoneCountryCode: "",
		datebirth: azureUserText,
		gender: "",
		photoUrl: "",
		termsAndConditionAgreements: [],
	};

	//Functions
	async function loadData(originUserId: string) {
		try {
			loading = true;
			const [userResponse, getAccessConrolResponse] =
				await Promise.all([
					$api.getUser(originUserId),
					$api.getAccessControlByUserId(originUserId),
				]);

			if (originUserId !== userId) {
				return;
			}

			user = userResponse.data;
			if (userResponse.data.authProvider === "AZURE") {
				profile = azureProfile;
			} else {
				const localProfile = await $api.getProfile(originUserId);
				profile = localProfile.data;
			}

			accessControlList =
				getAccessConrolResponse.data.accessControlListDTO.accessControlDTOList;
		} catch (error) {
			console.log(error);
		} finally {
			loading = false;
		}
	}
	function deleteButtonHandler(originUserId: string) {
		//
		if (loading) return;
		const cancel = () => ($popup = undefined);
		const accept = async () => {
			await deleteUser(originUserId);
			cancel();
		};

		$popup = {
			component: AreYouSure,
			props: {
				accept,
				cancel,
				textTranslation: "mbr.user.Are_you_sure_you_want_delete_this_user",
			},
		};
	}

	async function deleteUser(originUserId: string) {
		try {
			await $api.deleteUser(originUserId);
			navigate("/users");
		} catch (error) {
			alert($t("sso.error.unknownError"));
			console.log(error);
		} finally {
			loading = false;
		}
	}

	//Do
	$: loadData(userId);
	onDestroy(() => {
		$popup = undefined;
	});
</script>

{#if loading}
	<ContainerLoading />
{/if}

{#if user && profile && accessControlList}
	<div class="container">
		<div class="profile-additional">
			<div class="profile">
				<Profile bind:profile={profile} user={user} />
			</div>
			<div class="additional">
				<AdditionalInfo user={user} />
			</div>
		</div>
		<div class="admin">
			<OwnStore accessControlList={accessControlList} />
		</div>
		<div class="user-event-logging">
			<UserEventLogging userId={userId} />
		</div>
	</div>
	<div class="delete-box">
		<DefaultButton
			on:click={() => deleteButtonHandler(userId)}
			nonePadding
			fitmode
			background={deleteButtonBackground}
		>
			<div class="delete-button-layout">
				<span class="icon">
					<DeleteIcon />
				</span>
				<span class="text">{$t("mbr.user.delete_user")}</span>
			</div>
		</DefaultButton>
	</div>
{/if}

<style lang="scss">
	@import "../../variables.scss";
	.delete-box {
		position: absolute;
		top: 18px;
		right: 20px;
		.delete-button-layout {
			display: flex;
			gap: 10px;
			color: white;
			font-weight: 500;
			height: 32px;
			box-sizing: border-box;
			padding: 6px 31px;
			align-items: center;
			.icon {
				width: 20px;
				height: 20.1px;
			}
			.text {
				font-size: 1rem;
			}
		}
	}
	.container {
		display: flex;
		flex-direction: column;
		padding-top: 60px;
		position: relative;
		gap: 20px;

		.profile-additional {
			display: flex;
			flex-direction: column;
			gap: 20px;
		}
	}

	@include DesktopSize {
		.delete-box {
			top: 40px;
			.delete-button-layout {
				height: 40px;
				padding: 7.95px 40px;
				.icon {
					width: 24px;
					height: 24.2px;
				}

				.text {
					font-size: 1.25rem;
					margin-top: -2px;
				}
			}
		}

		.container {
			padding-top: 90px;
			.profile-additional {
				flex-direction: row;
				flex-wrap: wrap;
				gap: 30px;
				.profile {
					/*  */

					flex-basis: calc((100% - 30px) * (900 / 1564));
					flex-grow: 1;
				}
				.additional {
					min-width: 600px;
					min-height: 633px;
					flex-basis: calc((100% - 30px) * (664 / 1564));
					flex-grow: 1;
				}
			}
		}
	}
</style>
